module.exports = {
      id: "paypal-usage",
      viewBox: "0 0 160 40",
      url: __webpack_public_path__ + "img/icons.09862bea.svg#paypal",
      toString: function () {
        return this.url;
      }
    }